export function safeClone<T>(array: T[]): T[] {
  return [...(array ?? [])]
}

/**
 * Array vazio
 */
export const emptyArray: ReadonlyArray<any> = []
